<div class="container-fluid p-5">
    <!-- <div class="row pt-4">
        <div class="col-sm-6" [ngClass]="
                this.updatedtheme === 'dark' ? 'headlinetextD' : 'headlinetextL'
            ">
            <h3 class="pl-4 card-header card-headerL">Set Target</h3>
        </div>
    </div> -->
  
      
            <div class="row pt-3">
                <div class="col-md-12  overflow-auto mb-5 ct_custom_flex_basisc"
                    [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
                    <div class="row">
                        <div class="" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'User-headD'
                                    : 'User-headL'
                            ">
                            <div
                                class="card-header card-headerL ct_header_grey_1202 d-flex align-items-center justify-content-between">
                                <h4 class=" ct_fw_600 m-0 my-0" style="flex: 1;">Vendors</h4>
                                <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-3"
                                    (click)="showAddGroupDialog(1)">
                                    + Add vendor
                                </button>
                            </div>
                        </div>

                    </div>

                    <p-toast></p-toast>
                    <p-confirmDialog #cd [style]="{width: '60vw'}">
                        <ng-template pTemplate="footer">
                            <button pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"
                                class="span-color cancel-button"></button>
                            <button pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"
                                class="p-button-raised p-button-danger"></button>
                        </ng-template>
                    </p-confirmDialog>





                    <div class="dataTable scrollit mt-4 ct_vender_scroll_320">
                        <table class="table_loc ct_space_table_21 ct_billing_table_bg_120 ">
                            <thead>
                                <tr>

                                    <th scope="col" style="font-size: 16px;">S.No.</th>
                                    <th scope="col" style="font-size: 16px;">Name </th>
                                    <th scope="col" style="font-size: 16px;">Country </th>
                                    <th scope="col" style="font-size: 16px;">Reference Id</th>
                                    <th scope="col" style="font-size: 16px;">Address</th>
                                    <th scope="col" style="font-size: 16px;">Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr clickable (click)="selectGroup(group,index)" *ngFor="
                                        let group of groupsList;let index = index
                                    " class="col-12 tableRow border-bottom rounded pointer"
                                    (click)="UnlockComplete(group.id)"
                                    [ngClass]="{ 'tableRowclicked': index === selectedRowIndex }">
                                    <td class="td text-initial" style="font-size: 16px;">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="td " style="font-size: 16px;">
                                        {{ group.name }}

                                    </td>
                                    <td class="td " style="font-size: 16px;">
                                        {{ group.country_name }}

                                    </td>
                                    <td class="td  pb-1" style="font-size: 16px;">
                                        {{ group.refer_id }}

                                    </td>
                                    <td class="td  pb-1" style="font-size: 16px;">
                                        {{ group.address }}

                                    </td>
                                    <td class="td pb-1" (click)="viewDetails(group)">
                                        <i class="fas fa-edit"></i>
                                    </td>


                                </tr>
                            </tbody>
                        </table>
                        <div class="text-light" *ngIf="groupdata === false">
                            <div class="icon">
                                <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                            </div>
                            <label class="text-center label">No group available. Start by add a new group using the
                                add group button.</label>
                        </div>
                    </div>
                </div>


            </div>

     









        <!-- dhdfjhfjfgk -->
        <!-- <p-tabPanel header="Cost Centre">
            <div class="row pt-3">
                <div class="col-md-12  overflow-auto mb-5 ct_custom_flex_basisc"
                    [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
                    <div class="row">
                        <div class="" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'User-headD'
                                    : 'User-headL'
                            ">
                            <div
                                class="card-header card-headerL ct_header_grey_1202 d-flex align-items-center justify-content-between">
                                <h4 class=" ct_fw_600 m-0 my-0" style="flex: 1;">Cost Centre</h4>
                                <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-3"
                                    (click)="showAddGroupDialog('2')">
                                    + Add Cost Centre
                                </button>
                            </div>
                        </div>

                    </div>

                    <p-toast></p-toast>
                    <p-confirmDialog #cd [style]="{width: '60vw'}">
                        <ng-template pTemplate="footer">
                            <button pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"
                                class="span-color cancel-button"></button>
                            <button pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"
                                class="p-button-raised p-button-danger"></button>
                        </ng-template>
                    </p-confirmDialog>





                    <div class="dataTable scrollit mt-4">
                        <table class="table_loc ct_space_table_21 ct_billing_table_bg_120">
                            <thead>
                                <tr>

                                    <th scope="col" style="width: 400px; font-size: 16px;">S.No.</th>
                                    <th scope="col" style="width: 400px;font-size: 16px;"> Cost Centre Name </th>
                                    <th scope="col" style="font-size: 16px;">Reference ID</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr clickable (click)="selectGroup(group,index)" *ngFor="
                                        let group of groupsCostList;let index = index
                                    " class="col-12 tableRow border-bottom rounded pointer"
                                    (click)="UnlockComplete(group.id)"
                                    [ngClass]="{ 'tableRowclicked': index === selectedRowIndex }">
                                    <td class="td text-initial" style="width: 300px; font-size: 16px;">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="td " style="width: 400px; font-size: 16px;">
                                        {{ group.cost_center_name }}

                                    </td>
                                    <td class="td  pb-1" style="font-size: 16px;">
                                        {{ group.cost_center_refer_id }}

                                    </td>


                                </tr>
                            </tbody>
                        </table>
                        <div class="text-light" *ngIf="groupdata === false">
                            <div class="icon">
                                <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                            </div>
                            <label class="text-center label">No group available. Start by add a new group using the
                                add group button.</label>
                        </div>
                    </div>
                </div>


            </div>
        </p-tabPanel> -->


   

</div>



<p-dialog (click)="removeCss()" [(visible)]="visible" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}">
    <p-header *ngIf="FormEdit === false"> Add New Vendor </p-header>
    <p-header *ngIf="FormEdit === true"> Edit Vendor Details </p-header>

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll">
        <form #GroupForm="ngForm" class="col-12" (ngSubmit)="
            FormEdit === false
                ? saveVendors(GroupForm)
                : updateVendor( GroupForm)
        ">
            <div class="mb-5 pb-0 row">
                <div class="col-md-6 mb-3">
                    <label for="fname">Name</label>
                    <input name="vendor_name" ngModel id="search-input" type="text"
                      class="form-control Dashboard-tab text-white" placeholder="Enter Name"
                      #groupName="ngModel" [disabled]="isloading" required />
                    <!-- Error messages -->
                    <p class="text-danger mb-0" *ngIf="(groupName.touched || GroupForm.submitted) && groupName.errors?.['required']">
                      Name is required
                    </p>
                    <p class="text-danger mb-0" *ngIf="isgroupExist === true && groupName.touched">
                      Group already exists, please use another group name.
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    
                        <label for="fname">Country</label>
                        <p-dropdown class="finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                          ngModel name="country" placeholder="Select" [options]="countryData" [filter]="true" filterBy="Name"   (onShow)="handleDropdownShow()"  (onHide)="handleDropdownHide()" filterInputAutoFocus="false"
                          optionLabel="Name" optionValue="ID" styleClass="facilitydropdown" #country="ngModel" required>
                        </p-dropdown>
                        <p class="text-danger mb-0" *ngIf="(country.touched || GroupForm.submitted) && country.errors?.['required']">
                          Country is required.
                        </p>

                   
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="fname">Reference Id</label>
                    <input ngModel id="search-input" type="text" class="form-control Dashboard-tab text-white" name="refer_id"
                      placeholder="Enter reference id" #referId="ngModel" [disabled]="isloading" required />
                    <p class="text-danger mb-0" *ngIf="(referId.touched || GroupForm.submitted) && referId.errors?.['required']">
                      Reference ID is required.
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="fname">Address</label>
                    <input ngModel id="search-input" type="text" class="form-control Dashboard-tab text-white" name="address"
                      placeholder="Enter address" #address="ngModel" [disabled]="isloading" required />
                    <p class="text-danger mb-0" *ngIf="(address.touched || GroupForm.submitted) && address.errors?.['required']">
                      Address is required.
                    </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="fname">Scorecard</label>
                    <p-dropdown class="finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                    ngModel name="scorecard" placeholder="Select" [options]="scorecardData" [filter]="true" filterBy="calculationmethod"   (onShow)="handleDropdownShow()"  (onHide)="handleDropdownHide()" filterInputAutoFocus="false"
                    optionLabel="calculationmethod" optionValue="calculationmethod" styleClass="facilitydropdown" #country="ngModel" required>
                  </p-dropdown>
                  <p class="text-danger mb-0" *ngIf="(country.touched || GroupForm.submitted) && country.errors?.['required']">
                    Country is required.
                  </p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="fname">Target Status</label>
                    <p-dropdown class="finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                    ngModel name="targetStatus" placeholder="Select" [options]="targetStatusData" [filter]="true" filterBy="calculationmethod"   (onShow)="handleDropdownShow()"  (onHide)="handleDropdownHide()" filterInputAutoFocus="false"
                    optionLabel="calculationmethod" optionValue="calculationmethod" styleClass="facilitydropdown" #country="ngModel" required>
                  </p-dropdown>
                  <p class="text-danger mb-0" *ngIf="(country.touched || GroupForm.submitted) && country.errors?.['required']">
                    Country is required.
                  </p>
                  </div>




            </div>
            <div style="height: 80px;"></div>

            <div class="mt-3 ct_modal_btns_12">
                <Button (click)="removeCss()" type="submit" *ngIf="FormEdit === false" [disabled]="
                    (this.selectedRole !== Roleaccess &&
                        facilitydata === true) ||
                    usernameIsExist === true ||
                    emailIstExist === true
                " class="rounded span-color px-3 text-white text-style loading ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Save
                </Button>
                <Button *ngIf="FormEdit === true" type="submit " class="rounded span-color px-3 text-white text-style ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Update
                </Button>

                <span type="button" class="text-white font-weight-light ml-3 " (click)="removeCss()"
                    (click)="onCloseHandled()">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>


<p-dialog (click)="removeCss()" [(visible)]="visible2" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}">
    <p-header *ngIf="FormEdit === false"> Add Cost Centre </p-header>
    <p-header *ngIf="FormEdit === true"> Edit Vendor </p-header>

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll">
        <form #GroupCostForm="ngForm" class="col-12" (ngSubmit)="
            FormEdit === false
                ? saveCostCentre(GroupCostForm)
                : updateVendor(GroupCostForm.value)
        ">
            <div class="mb-5 pb-0 row">
                <div class="col-md-6 mb-3">
                    <label for="fname"> Cost centre name</label>
                    <input name="cost_center_name" ngModel id="search-input" type="text"
                        class="form-control Dashboard-tab text-white" placeholder="Enter Name" #groupName="ngModel"
                        [disabled]="isloading" required />
                    <p class="text-danger mb-0" *ngIf="GroupCostForm.submitted && groupName.errors?.['required']">
                        Name is required
                    </p>
                    <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="fname">Reference Id </label>
                    <input ngModel id="search-input" type="text" class="form-control Dashboard-tab text-white "
                        name="cost_center_refer_id" placeholder="Enter address" #groupName="ngModel"
                        [disabled]="isloading" required>
                    <!-- <p class="text-danger mb-0" *ngIf="GroupForm.submitted && groupName.errors?.['required']">
                        Group name is required
                    </p> -->
                    <!-- <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p> -->
                </div>




            </div>
            <div style="height: 80px;"></div>

            <div class="mt-3 ct_modal_btns_12">
                <!-- <Button (click)="removeCss()" type="submit" *ngIf="FormEdit === false" [disabled]="
                    (this.selectedRole !== Roleaccess &&
                        facilitydata === true) ||
                    usernameIsExist === true ||
                    emailIstExist === true
                " class="rounded span-color px-3 text-white text-style loading ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Save
                </Button> -->
                <Button *ngIf="FormEdit === true" type="submit " class="rounded span-color px-3 text-white text-style ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Update
                </Button>

                <span type="button" class="text-white font-weight-light ml-3 " (click)="removeCss()"
                    (click)="onCloseHandled()">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>